import _ from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Snackbar } from '@mui/material';
import { ReactComponent as ContentCopy } from '@/img/bookings/copy.svg';
import BankDetailRow from './BankDetailRow.react';
import { copyToClipboard } from './utils';

const BANK_DETAIL_FIELDS = [
	{ key: 'account_name', labelKey: 'Bookings.SettlePayment.AccountName' },
	{ key: 'bank_name', labelKey: 'Bookings.SettlePayment.BankName' },
	{ key: 'branch_number', labelKey: 'Bookings.SettlePayment.BranchNumber' },
	{ key: 'account_number', labelKey: 'Bookings.SettlePayment.AccountNumber' },
	{ key: 'id', labelKey: 'Bookings.SettlePayment.BankTransferId' },
	{ key: 'iban', labelKey: 'Bookings.SettlePayment.Iban' },
];

const BankTransferDetailsPanel = ({ bankDetails }) => {
	const { t } = useTranslation();

	const [copyFlash, setCopyFlash] = useState(false);

	const handleCopy = (value) => {
		copyToClipboard(value);
		setCopyFlash(true);

		setTimeout(() => {
			setCopyFlash(false);
		}, 4000);
	};

	const handleCopyAll = () => {
		if (!bankDetails) return;
		const text = BANK_DETAIL_FIELDS.map(({ labelKey, key }) => `${t(labelKey)}: ${bankDetails[key] || ''}`).join('\n');
		handleCopy(text);
	};

	return (
		<>
			<div className="bank-transfer__details-header">
				<div className="bank-transfer__details-title">{t('Bookings.SettlePayment.BankTransferDetails')}</div>
				<Button
					size="small"
					onClick={handleCopyAll}
					disabled={!bankDetails}
					className="bank-transfer__copy-all"
				>
					<span>{t('Bookings.SettlePayment.CopyAllDetails')}</span>
					<ContentCopy width={16} height={16} />
				</Button>
			</div>

			<div className="bank-transfer__details-box">
				{_.chunk(BANK_DETAIL_FIELDS, 2).map((pair, rowIndex) => (
					<div className="bank-transfer__details-row-pair" key={rowIndex}>
						{pair.map(({ key, labelKey }) => (
							<BankDetailRow key={key} labelKey={labelKey} value={bankDetails?.[key] || ''} onCopy={handleCopy} />
						))}
					</div>
				))}
			</div>

			<Snackbar open={copyFlash} message={t('BankDetailsCopied')} autoHideDuration={4000} />
		</>
	);
};

export default BankTransferDetailsPanel;
